var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompareArrows(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_249_1612)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.2588 58.7904H11.3166C8.94255 58.7904 7.00012 60.7328 7.00012 63.1069C7.00012 65.481 8.94255 67.4234 11.3166 67.4234H37.2588V75.1499C37.2588 77.0924 39.5897 78.042 40.9278 76.6607L52.9277 64.6177C53.7478 63.7544 53.7478 62.4163 52.9277 61.553L40.9278 49.5099C39.5897 48.1287 37.2588 49.1214 37.2588 51.0207V58.7904ZM63.0715 49.2509V41.5244H89.0136C91.3877 41.5244 93.3301 39.582 93.3301 37.2079C93.3301 34.8338 91.3877 32.8914 89.0136 32.8914H63.0715V25.1649C63.0715 23.2224 60.7406 22.2728 59.4024 23.6541L47.4026 35.6971C46.5824 36.5604 46.5824 37.8985 47.4026 38.7618L59.4024 50.8049C60.7406 52.143 63.0715 51.1934 63.0715 49.2509Z",
    fill: "#F84343"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_249_1612"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompareArrows);
export default __webpack_public_path__ + "static/media/compare_arrows.48875c0a5e7936c728094172819781c4.svg";
export { ForwardRef as ReactComponent };